var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 43,
    viewBox: "0 0 88 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0806 15.707H87.5881V42.35H81.0806V15.707Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.426 8.98438C63.0436 8.98438 58.6641 13.3507 58.6641 18.7169V42.3523H65.1716V32.388H71.6791V42.3523H78.1866V18.7169C78.1866 13.3507 73.8071 8.98438 68.4247 8.98438H68.426ZM71.6804 25.9001H65.1729V18.7169C65.1729 16.9277 66.6327 15.4723 68.4273 15.4723C70.2219 15.4723 71.6817 16.9277 71.6817 18.7169V25.9001H71.6804Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1728 4.26966L80.9293 0.178785C80.7978 -0.0595951 80.4537 -0.0595951 80.3236 0.178785L78.08 4.26966C78.0481 4.32793 78.0003 4.3756 77.9432 4.40606L73.84 6.64287C73.6009 6.77398 73.6009 7.11698 73.84 7.24676L77.9432 9.48357C78.0016 9.51535 78.0495 9.56303 78.08 9.61997L80.3236 13.7108C80.4551 13.9492 80.7991 13.9492 80.9293 13.7108L83.1728 9.61997C83.2047 9.5617 83.2525 9.51403 83.3097 9.48357L87.4129 7.24676C87.652 7.11565 87.652 6.77265 87.4129 6.64287L83.3097 4.40606C83.2512 4.37428 83.2034 4.3266 83.1728 4.26966Z",
    fill: "#FFD151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5907 39.2972C15.5907 41.3301 14.5639 42.3458 12.5116 42.3458H3.01532C1.00555 42.3458 0 41.3301 0 39.2972V31.0877H4.98258V38.0603H10.5855V8.97656H15.5907V39.2972Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4432 39.2972C36.4432 41.3301 35.431 42.3458 33.4066 42.3458H22.5421C20.5603 42.3458 19.5693 41.3301 19.5693 39.2972V12.0464C19.5693 9.99895 20.5603 8.97656 22.5421 8.97656H33.4066C35.431 8.97656 36.4432 10.0003 36.4432 12.0464V39.2972ZM31.4393 38.0603V13.2621H24.5745V38.0603H31.4393Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6649 42.3472H39.2881V39.6813L48.6555 13.4753H40.0359V8.97656H54.6224V11.8557L45.2762 37.8484H54.6649V42.3472Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotLogo);
export default __webpack_public_path__ + "static/media/botLogo.1cf3bd6094878d1058fedaa33bdf3f79.svg";
export { ForwardRef as ReactComponent };